export const APP_STATE_ACTIVE = 'active';
export const APP_STATE_INACTIVE = 'inactive';
export const APP_STATE_BACKGROUND = 'background';
